import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { DynamicTable, DynamicTable1 } from "./DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";

const GRI404_1 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const inputData = [
    {
      fieldName: "category",
      fields: [
        {
          fieldName: "categories",
          title: "Employee category",
          type: "select",
          options: [
            // "Full-Time employees",
            // "Part-Time employees",
            // "Workers",
            // "Governance",
            " Permanent Employees",
            "Temporary Employees",
            "Permanent Workers",
            "Temporary Workers",
            "Others",
          ],
          placeholder: "Type Here",
          width: "30%",
        },
        {
          fieldName: "male",
          title: "Male employees training hours",
          type: "number",
          placeholder: "Type Here",
          width: "25%",
        },
        {
          fieldName: "female",
          title: "Female employees training hours",
          type: "number",
          placeholder: "Type Here",
          width: "25%",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "groups",
      fields: [
        {
          fieldName: "ageGroup",
          title: "Age Group",
          type: "select",
          options: [
            "Age Under 30 years old",
            "Age 30-50 years old",
            "Age Over 50 years old",
          ],
          placeholder: "Type Here",
          width: "25%",
        },
        {
          fieldName: "hours",
          title: "Training hours",
          type: "number",
          placeholder: "Type Here",
          width: "25%",
        },
        {
          fieldName: "remark",
          title: "Remark",
          type: "text",
          placeholder: "Type Here",
          width: "25%",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);

  const [tables1, setTables1] = React.useState([]);

  const [tabErrors1, setTabErrors1] = useState({});

  const [tabErrors, setTabErrors] = useState({});
  const [data, setData] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);

        const data1 =
          response.data.data.GRI400?.AverageTrainingHoursPerEmployee || {};
        setData(data1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      // const isTableValid = validateTable(inputData, tables, setTabErrors);
      // const isTableValid1 = validateTable(inputData1, tables1, setTabErrors1);

      // if (!isTableValid || !isTableValid1) {
      //   return;
      // }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);
      const payload = {
        type: "GRI400",
        submitted404_1: true,
        AverageTrainingHoursPerEmployee: {
          ...transformedData,
          ...transformedData1,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/404-2/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/404-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
   
        {!hide && <p className={styles.section_heading}  style={{ marginBottom: hide ? "-1rem" : "0" }}>404 : Training and Education</p>}
    
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        404-1 : Average hours of training per year per employee
      </p>
      <Box>
        <SectionHeading text="a. What is the average number of training hours completed by employees of the organization during the reporting period? Please provide the breakdown:" />

        <Box sx={{ marginTop: "-2rem" }}>
          <DynamicTable
            inputData={inputData}
            tables={tables}
            setTables={setTables}
            data={data}
            disabled={disabled}
            errors={tabErrors}
            setErrors={setTabErrors}
            hide={hide}
          />
        </Box>

        <Box>
          <DynamicTable1
            inputData={inputData1}
            tables={tables1}
            setTables={setTables1}
            data={data}
            disabled={disabled}
            errors={tabErrors1}
            setErrors={setTabErrors1}
            hide={hide}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI404_1;
